import { AuthState } from 'app/page/auth/redux/model/auth-state';
import { AuthActionType } from 'app/page/auth/redux/model/auth-action-type';
import { AuthActions } from 'app/page/auth/redux/model/auth-actions';

const initialAuthState: AuthState = {};

const authReducer = (state: AuthState = initialAuthState, action: AuthActions): AuthState => {
    switch (action.type) {
        case AuthActionType.AUTHORIZE_START:
            return {
                ...state,
                stateParam: action.stateParam,
                codeVerifier: action.codeVerifier,
                authToken: undefined,
                failureReason: undefined,
            };
        case AuthActionType.AUTHORIZE_CALLBACK_SUCCESS:
            return {
                ...state,
                stateParam: undefined,
                authToken: action.authToken,
            };
        case AuthActionType.AUTHORIZE_CALLBACK_FAILURE:
            return {
                ...state,
                failureReason: action.reason,
            };
        case AuthActionType.AUTHORIZE_RESET: {
            return initialAuthState;
        }
        default:
            return state;
    }
};

export { authReducer };
